import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/orphaned/translation.orphaned.query.gql"
import type {
  TranslationOrphanedQuery,
  TranslationOrphanedQueryVariables,
} from "@/v2-backoffice-client/translation/orphaned/__types__/translation.orphaned.query"

type Options = QueryHookOptions<
  TranslationOrphanedQuery,
  TranslationOrphanedQueryVariables
>

export function useTranslationOrphanedQuery(options?: Options) {
  return useQuery<TranslationOrphanedQuery, TranslationOrphanedQueryVariables>(
    query,
    options,
  )
}
